import Vue from 'vue'
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'PnrYhOtqMcvwyLsv0F0ln4hUFQ00NWMY',
})
